import { logoColor, logoLight } from '../ui/media';
import { themeStore } from '../../stores/theme';
import { useStore } from '@tanstack/react-store';

const Footer = () => {
    const { isDarkMode } = useStore(themeStore)
    
    const Logo = () => {
        return (
          <div className="flex flex-col items-center">
            <img src={`${isDarkMode? logoLight : logoColor}`} className='h-[40px]' />
          </div>
        );
    };

    return (
        <footer className={`${isDarkMode?'bg-transparent': 'bg-white'} border-t border-t-[3px] border-t-[#029EFF]`}>
            <div className="container mx-auto py-4 px-6">
                <div className="flex flex-col md:flex-row justify-between items-center">
                    <Logo className="mb-4 md:mb-0" />
                    <div className="flex flex-wrap space-x-8">
                        <a href="/" className={`font-medium ${isDarkMode?'text-white': 'text-gray-800'}`}>Home</a>
                        <a href="/lander#about" className={`font-medium ${isDarkMode?'text-white': 'text-gray-800'}`}>About us</a>
                        <a href="/lander#services" className={`font-medium ${isDarkMode?'text-white': 'text-gray-800'}`}>Services</a>
                        <a href="/subscriptions" className={`font-medium ${isDarkMode?'text-white': 'text-gray-800'}`}>Subscriptions</a>
                        <a href="/lander#faq" className={`font-medium ${isDarkMode?'text-white': 'text-gray-800'}`}>FAQ</a>
                        <a href="/lander#contact" className={`font-medium ${isDarkMode?'text-white': 'text-gray-800'}`}>Contact us</a>
                        <a href="/privacy" className={`font-medium ${isDarkMode?'text-white': 'text-gray-800'}`}>Privacy Policy</a>
                        <a href="/terms" className={`font-medium ${isDarkMode?'text-white': 'text-gray-800'}`}>Terms</a>
                    </div>
                </div>
            </div>
            <div className={`py-4 text-center bg-blue-800 text-white`}>
                <p>© 2025 - All Rights Reserved - <a href="/" className="underline">ViewPort</a> | Designed & Developed by <a href="https://solidappmaker.com" className="underline">SolidAppMaker</a></p>
            </div>
        </footer>
    );
}
export default Footer;